// src/components/AccountCreation/Stepper.js
import React from 'react';
import { CheckIcon } from './Icons';

const Stepper = ({ currentStep, steps }) => {
    return (
        <div className="stepper-wrapper">
            {steps.map((step, index) => {
                const stepNumber = index + 1;
                const isActive = stepNumber === currentStep;
                const isCompleted = stepNumber < currentStep;
                let stepClass = "stepper-item";
                if (isActive) stepClass += " active";
                if (isCompleted) stepClass += " completed";
                return (
                    <div className={stepClass} key={index} data-label={step.label}>
                        <div className="step-counter">
                            <span className="step-number">{isCompleted ? <CheckIcon /> : stepNumber}</span>
                            <i className={`bi ${step.icon} step-icon`}></i>
                        </div>
                        <div className="step-name">{step.label}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
